<div class="center-flex">
  @for (filter of activeFilters; track filter) {
  <button
    id="filter-active-{{ filter.filterType }}"
    class="filter-button max-content"
    mat-raised-button
    (click)="goToCurrentClickedFilter(filter, $event)"
    [matTooltip]="filter.tooltipText"
  >
    <svg-icon class="fill-black" [svgStyle]="{ 'width.px': 16 }" src="{{ filter.icon }}"> </svg-icon>
    <!-- eliminate the last ccommunication long text for the main page filter -->
    @if (filter.filterType === FilterType.MEASUREMENT && selectedMeasurement) {
    <span> {{ selectedMeasurement.label | translate }} </span>
    } @else {
    {{ filter.label }}
    } @if (filter.filterType === FilterType.TYPES && selectedTypes.length > 0) {
    <span> ({{ selectedTypes.length }}) </span>
    } @if (filter.filterType === FilterType.LASTCOMMUNICATED) {
    <span>: {{ lastCommuncatedDateRange?.start | formatDate }} - {{ lastCommuncatedDateRange?.end | formatDate }}</span>
    } @if (filter.filterType === FilterType.UTILIZATION && selectedStatusLength > 0) {
    <span> ({{ selectedStatusLength }}) </span>
    } @if (filter.filterType === FilterType.PROJECTS && selectedProjects.length > 0) {
    <span> ({{ selectedProjects.length }}) </span>
    } @if (filter.filterType === FilterType.GEOFENCE && selectedGeofences.length > 0) {
    <span> ({{ selectedGeofences.length }}) </span>
    } @if (filter.filterType === FilterType.LOCATION && selectedLocations && selectedLocations.length > 0) {
    <span> ({{ selectedLocations.length }}) </span>
    } @if (filter.filterType === FilterType.AREA && searchInAreaCoords) {
    <span> ({{ "Search In Area" }}) </span>
    }
    <svg-icon
      [svgStyle]="{ 'width.px': 14 }"
      src="/assets/icons/close.svg"
      (click)="disableFilter(filter, $event)"
    ></svg-icon>
  </button>
  }
  <button
    id="btn-filter"
    class="hover-button margin-right-xs filter text-black width-90"
    [ngClass]="{ 'focus-button': isFilterClicked }"
    style="padding: 0 12px"
    (click)="setFilterSelectionStyle($event)"
  >
    <span>
      <svg-icon [svgStyle]="{ 'width.px': 16, 'height.px': 16 }" class="icon-hover" src="/assets/icons/filter.svg">
      </svg-icon>
      Filter
    </span>
  </button>
  @if (toggleSearchBar && !bp.isPhone()) {
  <app-search-field
    class="search-field"
    (keyUp)="setSearchControl($event)"
    [placeHolder]="'component.OVERVIEW.FORM-FIELD.PLACE_HOLDER' | translate"
    #searchcontrol
  ></app-search-field>
  }
</div>
@if (isFilterClicked) {
<div class="menu-backdrop"></div>
<div #filterMenuContainer class="menu-container box-shadow">
  @if (!selectedFilter) { @for (filter of filters; track filter) { @if (filter.shouldShowInList) {
  <button
    id="filter-{{ filter.filterType }}"
    class="button-size button-styling"
    [disabled]="filter.disabled"
    (click)="selectFilter(filter, $event)"
  >
    <div style="display: contents">
      <svg-icon
        [svgStyle]="{ 'width.px': 16 }"
        class="text-bottom-align pr-m pl-xxs"
        [ngClass]="filter.disabled ? 'grey-icon' : 'black-icon'"
        src="{{ filter.icon }}"
      >
      </svg-icon>
      {{ filter.label }}
    </div>
  </button>
  } } }
  <!------------------  When measurement is selected ----------------->
  @if (selectedFilter === FilterType.MEASUREMENT) {
  <app-filter-measurement
    [measurementOptions]="measurements"
    (apply)="onApplyFilter(FilterType.MEASUREMENT)"
    (back)="onApplyFilter(FilterType.MEASUREMENT)"
    (optionChange)="onMeasurementOptionChange($event)"
  ></app-filter-measurement>
  }
  <!------------------  When utilization is selected ----------------->
  @if (selectedFilter === FilterType.UTILIZATION) {
  <app-filter-utilization
    [utilizationOptions]="selectedStatus"
    (apply)="onApplyFilter(FilterType.UTILIZATION)"
    (back)="onApplyFilter(FilterType.UTILIZATION)"
    (optionChange)="onUtilizationOptionChange($event)"
  ></app-filter-utilization>
  }
  <!-----------------  when type is selected -------------->
  @if (selectedFilter === FilterType.TYPES) {
  <app-filter-type
    [typeOptions]="types"
    (apply)="onApplyFilter(FilterType.TYPES)"
    (back)="onApplyFilter(FilterType.TYPES)"
    (optionChange)="onTypeOptionChange($event)"
  ></app-filter-type>
  }
  <!-------------------------- when coutry filter is selected------------------>
  @if (selectedFilter === FilterType.LOCATION) {
  <app-filter-location
    [selectedLocations]="selectedLocations"
    (apply)="onApplyFilter(FilterType.LOCATION)"
    (back)="onApplyFilter(FilterType.LOCATION)"
    (optionChange)="onLocationOptionChange($event)"
  ></app-filter-location>
  }
  <!-----------------  when days in state filter is selected -------------->
  @if (selectedFilter === FilterType.DAYSINSTATE) {
  <app-filter-days-in-state
    [utilizationOptions]="selectedStatus"
    [selectedState]="selectedDaysInStateFilterState"
    (apply)="onApplyFilter(FilterType.DAYSINSTATE)"
    (back)="onApplyFilter(FilterType.DAYSINSTATE)"
    (optionChange)="onDaysInStateOptionChange($event)"
  ></app-filter-days-in-state>
  }
  <!-------------------------- ------------------>
  <!-----------------  when project is selected -------------->
  @if (selectedFilter === FilterType.PROJECTS) {
  <app-filter-project
    [projects]="projects"
    (apply)="onApplyFilter(FilterType.PROJECTS)"
    (back)="onApplyFilter(FilterType.PROJECTS)"
    (optionChange)="onSelectProjects($event)"
  ></app-filter-project>
  }
  <!-----------------  when geofence is selected -------------->
  @if (selectedFilter === FilterType.GEOFENCE) {
  <app-filter-geofence
    [geofenceOptions]="geofences"
    (apply)="onApplyFilter(FilterType.GEOFENCE)"
    (back)="onApplyFilter(FilterType.GEOFENCE)"
    (optionChange)="onSelectGeofences($event)"
  ></app-filter-geofence>
  }
  <!-- when last communicated filers is selected   -->
  @if (selectedFilter === FilterType.LASTCOMMUNICATED) {
  <app-filter-last-communicated
    (apply)="onApplyFilter(FilterType.LASTCOMMUNICATED)"
    (back)="closePicker()"
    (optionChange)="updateLastCommunicatedDateRange($event)"
  ></app-filter-last-communicated>
  }
  <!-- when humidity filters is selected-->
  @if (selectedFilter === FilterType.HUMIDITY) {
  <app-filter-humidity
    [selectedIntervalOption]="selectedHumidityIntervalOption"
    (apply)="onApplyFilter(FilterType.HUMIDITY)"
    (back)="onApplyFilter(FilterType.HUMIDITY)"
    (optionChange)="onUpdateHumidityRange($event)"
  ></app-filter-humidity>
  }
  <!-- when temperature filters is selected-->
  @if (selectedFilter === FilterType.TEMPERATURE) {
  <app-filter-temperature
    [selectedIntervalOption]="selectedTemperatureIntervalOption"
    (apply)="onApplyFilter(FilterType.TEMPERATURE)"
    (back)="onApplyFilter(FilterType.TEMPERATURE)"
    (optionChange)="onUpdateTemperatureRange($event)"
  ></app-filter-temperature>
  }
</div>
}
